import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import CryptoJS from "crypto-js";

Vue.use(Vuex);

// axios.defaults.baseURL = 'https://smartlibrary.ubru.ac.th/'
let secret_one = "";
let keycomponent = "";
let datas;

function encrypt_data(plaintext, secret) {
  let passphrase = CryptoJS.SHA384(secret_one).toString();
  let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
  datas.ciphertext = CryptoJS.AES.encrypt(plaintext, key, {
    iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
    mode: CryptoJS.mode.ECB,
    passphrase: CryptoJS.pad.Pkcs7,
  }).toString();
  passphrase = "";
  return {
    data: encrypt_once(JSON.stringify(datas), secret).toString(),
  };
}
function encrypt_once(plaintext, secret) {
  let passphrase = CryptoJS.SHA384(secret).toString();
  let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
  let ciptext = CryptoJS.AES.encrypt(JSON.stringify(plaintext), key, {
    iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
    mode: CryptoJS.mode.ECB,
    passphrase: CryptoJS.pad.Pkcs7,
  }).toString();
  return ciptext;
}
function decrypt_once(ciphertext, secret) {
  let passphrase = CryptoJS.SHA384(secret).toString();
  let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
  let bytes = CryptoJS.AES.decrypt(ciphertext, key, {
    iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
    mode: CryptoJS.mode.ECB,
    passphrase: CryptoJS.pad.Pkcs7,
  });
  let decrypted = bytes.toString(CryptoJS.enc.Utf8);
  return decrypted;
}
export default new Vuex.Store({
  state: {
    authenticated: false,
    status_: "",
    accesstoken: localStorage.getItem("access_token") || "",
    user: {},
  },
  mutations: {
    // setAuthentication(state, status) {
    //   state.authenticated = status;
    // },
    auth_request(state) {
      state.status_ = "loading";
    },
    auth_success(state, accesstoken) {
      state.status_ = "success";
      state.accesstoken = accesstoken;
      // state.user = user
    },
    auth_error(state) {
      state.status_ = "error";
    },
    logout(state) {
      state.status_ = "";
      state.access_token = "";
    },
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        let ip = localStorage.getItem("IP");

        let std;
        let curdate = new Date();
        curdate.setUTCHours(curdate.getUTCHours() + 7);
        let timespit = curdate
          .toISOString()
          .slice(0, 13)
          .split("T");
        let objDate = {
          date: timespit[0],
          time: timespit[1],
        };
        console.log('time spit === ',timespit);
        std = {
          token:
            "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK",
          username: user.std_code,
          password: user.password,
          public_ip: ip,
        };
        console.log(std);
        keycomponent =
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK"; //token+time;
        secret_one = keycomponent + objDate.date + " " + objDate.time;
        console.log("Secret one",secret_one);
        datas = {
          ciphertext: "",
          token: this.token_key,
        };

        let ciphertext = encrypt_data(JSON.stringify(std), secret_one);
        console.log("Login encrypt === ",ciphertext);
        const headers = {
          "content-type": "application/json",
        };

        axios
          .post("https://smartlibrary.ubru.ac.th/api/signin", ciphertext, {
            headers,
          })
          .then((res) => {
            let api_data = res.data[0].data;
            let chkerror = res.data[0].msg;
            if (chkerror.status !== 200) {
              commit("auth_error");
              // alert(chkerror.message);
              resolve(res.data[0]);
            } else {
              let decrypt_data = decrypt_once(api_data, secret_one);
              let data_parseJSON = JSON.parse(decrypt_data);
              localStorage.setItem("access_token", data_parseJSON.access_token);

              let decrypt_data2 = decrypt_once(
                data_parseJSON.ciphertext,
                secret_one
              );
              let original_data = JSON.parse(decrypt_data2);
              localStorage.setItem("auth", JSON.stringify(original_data));
              const accesstoken = data_parseJSON.access_token;
              // const user = original_data
              localStorage.setItem(
                "std_code",
                JSON.stringify(JSON.stringify(original_data.std_code))
              );
              localStorage.setItem("access", JSON.stringify(accesstoken));
              localStorage.setItem("login", true);
              axios.defaults.headers.common["Authorization"] = accesstoken;
              commit("auth_success", accesstoken);
              resolve(res.data[0]);
            }
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("access_token");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit("logout");

        localStorage.removeItem("access_token");
        localStorage.removeItem("std_code");
        localStorage.removeItem("login");
        localStorage.removeItem("auth");
        localStorage.removeItem("orders");
        localStorage.removeItem("staffcode");
        localStorage.removeItem("maxchk");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        let ip = localStorage.getItem("IP");
        let std;
        let curdate = new Date();
        curdate.setUTCHours(curdate.getUTCHours() + 7);
        let timespit = curdate
          .toISOString()
          .slice(0, 13)
          .split("T");
        let objDate = {
          date: timespit[0],
          time: timespit[1],
        };

        std = {
          token:
            "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
          std_code: user.std_code,
          email: user.email,
          phone_number: user.phone,
          public_ip: ip,
        };
        keycomponent =
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK"; //token+time;
        secret_one = keycomponent + objDate.date + " " + objDate.time;
        datas = {
          ciphertext: "",
          token: this.token_key,
        };
        let ciphertext = encrypt_data(JSON.stringify(std), secret_one);
        const headers = {
          "content-type": "application/json",
        };

        axios
          .post(
            "https://smartlibrary.ubru.ac.th/api/booking/register",
            ciphertext,
            { headers }
          )
          .then((res) => {
            let api_data = res.data[0].data;
            let chkerror = res.data[0].msg;

            if (chkerror.status !== 200) {
              commit("auth_error");
              // alert(chkerror.message);
              resolve(res.data[0]);
            } else {
              let decrypt_data = decrypt_once(api_data, secret_one);
              let data_parseJSON = JSON.parse(decrypt_data);

              let decrypt_data2 = decrypt_once(
                data_parseJSON.ciphertext,
                secret_one
              );
              let original_data = JSON.parse(decrypt_data2);
              localStorage.setItem(
                "std_code",
                JSON.stringify(original_data[0].std_code)
              );
              resolve(res.data[0]);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            localStorage.removeItem("acces_token");
            reject(err);
          });
      });
    },

    teacher({commit},user){
      return new Promise(()=>{
        commit("auth_request");
        console.log(user.email,"Teacher");
      });

    },
    anathor({commit},user){
      return new Promise (()=>{
        commit("auth_request");
        console.log(user.another_code,"another_code");
      })
    },

    
    verify({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        let ip = localStorage.getItem("IP");

        let std;
        let curdate = new Date();
        curdate.setUTCHours(curdate.getUTCHours() + 7);
        let timespit = curdate
          .toISOString()
          .slice(0, 13)
          .split("T");
        let objDate = {
          date: timespit[0],
          time: timespit[1],
        };
        let st = JSON.parse(localStorage.getItem("std_code"));
        std = {
          token:
            "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
          std_code: st,
          otp_code: user.otp,
          public_ip: ip,
        };
        keycomponent =
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK"; //token+time;
        secret_one = keycomponent + objDate.date + " " + objDate.time;
        datas = {
          ciphertext: "",
          token: this.token_key,
        };
        let ciphertext = encrypt_data(JSON.stringify(std), secret_one);
        const headers = {
          "content-type": "application/json",
        };

        axios
          .post(
            "https://smartlibrary.ubru.ac.th/api/booking/verify_otp",
            ciphertext,
            { headers }
          )
          .then((res) => {
            // console.log();
            let api_data = res.data[0].data;
            let api_msg = res.data[0].msg;
            if (api_msg.status !== 200) {
              resolve(res.data[0]);
            } else {
              // console.log("res verify",res);
              let decrypt_data = decrypt_once(api_data, secret_one);
              let data_parseJSON = JSON.parse(decrypt_data);
              localStorage.setItem("access_token", data_parseJSON.access_token);

              let decrypt_data2 = decrypt_once(
                data_parseJSON.ciphertext,
                secret_one
              );
              let original_data = JSON.parse(decrypt_data2);
              localStorage.setItem("profile", JSON.stringify(original_data));
              const access_token = data_parseJSON.access_token;
              const user = original_data.std_code;
              localStorage.setItem("std_code", original_data.std_code);
              localStorage.setItem("auth", JSON.stringify(original_data));
              localStorage.setItem("login", true);
              axios.defaults.headers.common["Authorization"] = access_token;
              commit("seccess", access_token, user);
              // resolve(user);
              resolve(res.data[0]);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            localStorage.removeItem("acces_token");
            reject(err);
          });
      });
    },
    send_phone({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        let ip = localStorage.getItem("IP");

        let std;
        let curdate = new Date();
        curdate.setUTCHours(curdate.getUTCHours() + 7);
        let timespit = curdate
          .toISOString()
          .slice(0, 13)
          .split("T");
        let objDate = {
          date: timespit[0],
          time: timespit[1],
        };
        let st = JSON.parse(localStorage.getItem("std_code"));
        std = {
          token:
            "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
          std_code: st,
          phone_number: user.phone,
          public_ip: ip,
        };
        keycomponent =
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK"; //token+time;
        secret_one = keycomponent + objDate.date + " " + objDate.time;
        datas = {
          ciphertext: "",
          token: this.token_key,
        };
        let ciphertext = encrypt_data(JSON.stringify(std), secret_one);
        const headers = {
          "content-type": "application/json",
        };

        axios
          .post(
            "https://smartlibrary.ubru.ac.th/api/booking/request_otp",
            ciphertext,
            { headers }
          )
          .then((res) => {
            resolve(res.data[0]);
          })
          .catch((err) => {
            commit("auth_error", err);
            localStorage.removeItem("acces_token");
            reject(err);
          });
      });
    },
  },
  modules: {},
  getters: {
    isLoggedIn: (state) => !!state.accesstoken,
    authStatus: (state) => state.status_,
  },
});
